import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import Tilt3D from "@/components/Tilt3D";
import { INDUSTRIES } from "@/data/content";

const MANUF_IMG =
  "https://images.unsplash.com/photo-1564182842834-681b7be6de4b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxtYW51ZmFjdHVyaW5nJTIwZmFjaWxpdHklMjB3b3JrZXJ8ZW58MHx8fHwxNzgzNDQ4MjMzfDA&ixlib=rb-4.1.0&q=85";

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <section className="py-20 md:py-28 border-b border-hairline">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <div className="md:col-span-8">
            <div className="overline text-terracotta mb-4">Industries served</div>
            <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-medium tracking-tight leading-[0.98] text-ink">
              Sector fluency
              <br />
              <span className="italic font-light text-forest">changes outcomes.</span>
            </h1>
          </div>
          <div className="md:col-span-4">
            <p className="text-muted2 leading-relaxed">
              Every one of our recruitment desks is staffed by consultants who have spent
              at least three years hiring for the sectors they cover.
            </p>
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-6">
          {INDUSTRIES.map((ind, i) => {
            const isFeature = i === 2;
            return (
              <Tilt3D
                key={ind.name}
                max={isFeature ? 3 : 5}
                scale={1.01}
                className={`${isFeature ? "md:col-span-6 md:row-span-2" : "md:col-span-3"}`}
              >
                <div
                  data-testid={`industry-${ind.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                  className={`h-full ${isFeature ? "bg-forest text-bone" : "bg-white"} border border-black/5 p-8 flex flex-col justify-between min-h-[240px] transition-shadow hover:shadow-2xl`}
                >
                  <div>
                    <div className={`overline ${isFeature ? "text-terracotta-soft" : "text-terracotta"}`}>
                      0{i + 1}
                    </div>
                    <h3 className={`font-display font-medium mt-4 tracking-tight ${isFeature ? "text-3xl md:text-4xl" : "text-xl"} ${isFeature ? "text-bone" : "text-ink"}`}>
                      {ind.name}
                    </h3>
                    <p className={`mt-3 text-sm leading-relaxed ${isFeature ? "text-bone/70" : "text-muted2"}`}>
                      {ind.roles}
                    </p>
                  </div>
                  {isFeature && (
                    <div className="mt-6 aspect-[16/9] overflow-hidden">
                      <img src={MANUF_IMG} alt={ind.name} className="w-full h-full object-cover" />
                    </div>
                  )}
                </div>
              </Tilt3D>
            );
          })}
        </div>
      </section>

      <section className="py-16 bg-[#F1EAEC]">
        <div className="max-w-5xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <SectionHeading
            overline="Sector not listed?"
            title="Chances are, we've hired for it."
          />
          <Link to="/contact" data-testid="industries-cta" className="btn-primary shrink-0">
            Ask about your sector <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
